export default __webpack_public_path__ + "static/media/routes_deactive.c3e1920d.svg";